import script from "./CameraTest.vue?vue&type=script&setup=true&lang=ts"
export * from "./CameraTest.vue?vue&type=script&setup=true&lang=ts"

import "./CameraTest.vue?vue&type=style&index=0&id=49c34878&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49c34878"]])

export default __exports__